import {put,} from '../utils'

export default host => () =>
  put(
    `${host}/users/updateShowLinks`);